export default {
    CONFIRM: 'WRONG_PROCESS.CONFIRM'
};
